<template>
  <div class="shadow bg-white p-4  mt-6 mb-10 rounded">
    <div v-if="!editMode">
      <vs-row vs-type="flex" vs-justify="space-between" class="pb-10" vs-w="12">
        <vs-button color="danger" type="filled" disabled="" v-if="content.type === '2'">Wichtig</vs-button>
        <vs-button color="success" type="filled" disabled="" v-if="content.type === '1'">Normal</vs-button>
        <vs-button @click="editMode=true" color="primary" type="filled">Bearbeiten</vs-button>
      </vs-row>
    </div>
    <div v-else>
      <vs-row vs-type="flex" vs-justify="space-between" class="pb-10" vs-w="12">
        <vs-button @click="editMode=false" color="danger" type="filled">Abbrechen</vs-button>
        <vs-button @click="update" color="success" type="filled" :disabled="disabled">{{saveText}}</vs-button>
      </vs-row>
    </div>
    <h1 class="text-center mb-5" :style="{color : content.titlecolor}">{{content.title}}</h1>
    <img style="width: 100%" v-if="!editMode" :src="imageUrl" />
    <div v-if="!editMode" v-html="content.description" vs-w="12"/>
    <div v-else>
      <vs-input
        type="text"
        name="title"
        icon-no-border
        icon-pack="feather"
        label-placeholder="Titel"
        v-model="content.title"
        :style="{color : content.titlecolor}"
        class="w-full mt-6 mb-6"/>
      <vs-row vs-type="flex" class="mt-6 mb-6">
        <span class="pr-4">Titel Farbe</span>
        <input
          type="color"
          @change="onColorChanged($event)"
          v-model="content.titlecolor"
        >
      </vs-row>
      <vs-checkbox v-model="content.showtitle" class="mt-6 mb-6">Titel anziegen</vs-checkbox>

      <vs-row vs-type="flex" class="mt-6 mb-6" v-if="content.type === '1'">
        <span class="pr-4">Neues Bild hochladen</span>
        <input
          type="file"
          accept="image/*"
          @change="onFileChanged"
        >
      </vs-row>

      <quill-editor style="width: 100%;" v-model="content.description" placeholder="Marktdetails"></quill-editor>
      <vs-checkbox v-model="content.isactive" class="mt-6 mb-6">Inhalt aktiv</vs-checkbox>
    </div>
  </div>
</template>

<script>
  import {quillEditor} from 'vue-quill-editor'
  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'
  import {mapActions} from 'vuex'

  export default {
    name: "ContentComponent",
    props: {
      contentItem: {
        type: Object
      }
    },
    components: {
      quillEditor
    },
    data: function () {
      return {
        editMode: false,
        content: {},
        saveText: 'Speichern',
        disabled: false,
        imageUrl: '',
      }
    },
    mounted() {
      this.content = {...this.contentItem}
      this.imageUrl = this.content.imagepath
    },
    methods: {
      ...mapActions(['updateContent']),
      ...mapActions(['fetchHomeContent']),
      onColorChanged(e) {
        this.titleColor = e.target.value
      },
      getBase64(file) {
        return new Promise(function (resolve, reject) {
          let reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result)
          reader.onerror = (error) => reject('Error: ', error);
        })
      },
      onFileChanged(event) {
        const file = event.target.files[0]
        this.getBase64(file)
          .then((result) => {
            this.content.base64_image = result
          })
          .catch(e => console.log(e))
      },
      update() {
        this.saveText = 'lädt...';
        this.disabled = true;
        this.updateContent(this.content).then((res) => {
          this.editMode = false
          this.saveText = 'Speichern';
          this.disabled = false;
          if (res === true) {
            this.fetchHomeContent().then(() => {
              this.imageUrl = this.$store.getters.getHomeContent.find(c => c.id === this.content.id).imagepath;
              this.$toast.success('Inhalt erfolgreich aktualisiert')
            })
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>
